var map = {
	"./translations.de-DE.json": 44384,
	"./translations.en-US.json": 11151,
	"./translations.pl-PL.json": 23778,
	"./translations.uk-UA.json": 99896,
	"./translations.vi-VN.json": 38397,
	"./translations.zh-CN.json": 37169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63382;